export default [
  {
    resource: "real-estate",
    header: "Venda i Lloguer",
  },
  {
    action: "manage",
    resource: "real-estate",
    icon: "HomeIcon",
    title: "Propietats",
    route: "foravila-real-estate-accommodations-list",
  },
  {
    action: "manage",
    resource: "real-estate",
    icon: "UserIcon",
    title: "Clients",
    route: "foravila-real-estate-clients-list",
  },
];
